import React, { useState, useRef } from 'react';
import { graphql } from 'gatsby';
import Modal from './Modal';
import LitStructuredText from './generic/LitStructuredText';
import { doRecaptchaAction } from '../util/util';
import SimplePagePopUp from './SimplePagePopUp';
import { Container } from 'react-bootstrap';

const ModularInfluencerForm = ({ data }) => {
  const [privacyOptIn, setPrivacyOptIn] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [contactno, setContactno] = useState('');
  const [message, setMessage] = useState('');
  const [date, setDate] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [formSubmit, setFormSubmit] = useState(false);
  const [formSubmitError, setFormSubmitError] = useState(false);
  const [animation, setAnimation] = useState(false);
  const [dialogShow, setDialogShow] = useState(true);
  const [existingCustomer, setExistingCustomer] = useState(false);
  const [checkYoutube, setCheckYoutube] = useState();
  const [checkInstagram, setCheckInstagram] = useState();
  const [checkTikTok, setCheckTikTok] = useState();
  const [checkFacebook, setCheckFacebook] = useState();
  const [checkPinterest, setCheckPinterest] = useState();
  const [checkTwitch, setCheckTwitch] = useState();
  const [checkKick, setCheckKick] = useState();
  const [numberSubsYoutube, setNumberSubsYoutube] = useState();
  const [numberSubsInstagram, setNumberSubsInstagram] = useState();
  const [numberSubsTikTok, setNumberSubsTikTok] = useState();
  const [numberSubsFacebook, setNumberSubsFacebook] = useState();
  const [numberSubsPinterest, setNumberSubsPinterest] = useState();
  const [numberSubsTwitch, setNumberSubsTwitch] = useState();
  const [numberSubsKick, setNumberSubsKick] = useState();
  const [usernameYoutube, setUsernameYoutube] = useState();
  const [usernameInstagram, setUsernameInstagram] = useState();
  const [usernameTikTok, setUsernameTikTok] = useState();
  const [usernameFacebook, setUsernameFacebook] = useState();
  const [usernamePinterest, setUsernamePinterest] = useState();
  const [usernameTwitch, setUsernameTwitch] = useState();
  const [usernameKick, setUsernameKick] = useState();

  const modal = useRef(null);

  const switchDialog = () => {
    const dialog = modal.current;
    setDialogShow((prevState) => !prevState);
    if (dialogShow) {
      dialog.showModal();
      setAnimation('open-modal');
    } else {
      setAnimation('close-modal');
      setTimeout(() => {
        dialog.close();
      }, 200);
    }
  };

  const platformObjectArray = [
    {
      label: 'Youtube',
      platformState: checkYoutube,
      setPlatformState: setCheckYoutube,
      numberSubsState: numberSubsYoutube,
      setNumberSubsState: setNumberSubsYoutube,
      usernameState: usernameYoutube,
      setUsernameState: setUsernameYoutube,
      gridColumn: `column-1`,
    },
    {
      label: 'Instagram',
      platformState: checkInstagram,
      setPlatformState: setCheckInstagram,
      numberSubsState: numberSubsInstagram,
      setNumberSubsState: setNumberSubsInstagram,
      usernameState: usernameInstagram,
      setUsernameState: setUsernameInstagram,
      gridColumn: `column-3`,
    },
    {
      label: 'TikTok',
      platformState: checkTikTok,
      setPlatformState: setCheckTikTok,
      numberSubsState: numberSubsTikTok,
      setNumberSubsState: setNumberSubsTikTok,
      usernameState: usernameTikTok,
      setUsernameState: setUsernameTikTok,
      gridColumn: `column-1`,
    },
    {
      label: 'Facebook',
      platformState: checkFacebook,
      setPlatformState: setCheckFacebook,
      numberSubsState: numberSubsFacebook,
      setNumberSubsState: setNumberSubsFacebook,
      usernameState: usernameFacebook,
      setUsernameState: setUsernameFacebook,
      gridColumn: `column-3`,
    },
    {
      label: 'Pinterest',
      platformState: checkPinterest,
      setPlatformState: setCheckPinterest,
      numberSubsState: numberSubsPinterest,
      setNumberSubsState: setNumberSubsPinterest,
      usernameState: usernamePinterest,
      setUsernameState: setUsernamePinterest,
      gridColumn: `column-1`,
    },
    {
      label: 'Twitch',
      platformState: checkTwitch,
      setPlatformState: setCheckTwitch,
      numberSubsState: numberSubsTwitch,
      setNumberSubsState: setNumberSubsTwitch,
      usernameState: usernameTwitch,
      setUsernameState: setUsernameTwitch,
      gridColumn: `column-3`,
    },
    {
      label: 'Kick',
      platformState: checkKick,
      setPlatformState: setCheckKick,
      numberSubsState: numberSubsKick,
      setNumberSubsState: setNumberSubsKick,
      usernameState: usernameKick,
      setUsernameState: setUsernameKick,
      gridColumn: `column-1`,
    },
  ];

  const getDateOfBirthMax = (date) => {
    let month = date.getMonth() + 1;
    if (month < 10) month = '0' + month;

    let day = date.getDate();
    if (day < 10) day = '0' + day;
    return `${date.getFullYear()}-${month}-${day}`;
  };

  const today = new Date();
  const maxDate = new Date(
    today.getFullYear() - 16,
    today.getMonth(),
    today.getDate(),
  );

  const handleSubmit = (e) => {
    e.preventDefault();

    let sendPlatforms = [];
    platformObjectArray.forEach((platformObject) => {
      platformObject.platformState &&
        sendPlatforms.push({
          label: platformObject.label,
          numberOfSubs: platformObject.numberSubsState,
          username: platformObject.usernameState,
        });
    });

    return doRecaptchaAction((token) => {
      fetch(`${process.env.GATSBY_ORDER_API_ADDRESS}email/influencer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Captcha-Token': `${token}`,
          ApiKey: `${process.env.GATSBY_ORDER_API_KEY}`,
        },
        body: JSON.stringify({
          template: 'InfluencerEnquiry',
          influencerEmail: `${email}`,
          fullName: `${name}`,
          phoneNumber: `${contactno}`,
          dateOfBirth: `${date}`,
          accountNumber: `${accountNumber}`,
          platforms: sendPlatforms,
          message: `${message}`,
          parameters: {},
        }),
      })
        .then((response) => {
          if (response.ok) {
            setFormSubmit(true);
            if (typeof window !== undefined) {
              window.scrollTo({
                top: 100,
                left: 100,
                behavior: 'smooth',
              });
            }
          }
        })
        .catch((error) => {
          setFormSubmitError('Failed to submit Lit Ambassador form');
          console.log(error);
        });
    }, 'influencer_email');
  };
  const { formHeading, legalTermsContent } = data;

  return (
    <div className="form-container White">
      {!formSubmit && (
        <div className="form-heading">
          <LitStructuredText data={formHeading} basic />
        </div>
      )}
      {!formSubmit && (
        <div className="form-wrapper">
          <form
            onSubmit={(e) => {
              handleSubmit(e);
            }}
            className="form"
          >
            <div className="form-input-container">
              <div className="form-input-inner column-1">
                <label htmlFor="name">Full name*</label>
                <input
                  type="text"
                  name="Name"
                  required
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="form-input-inner column-3">
                <label htmlFor="Date">Date of birth*</label>
                <input
                  type="date"
                  name="Date"
                  required
                  value={date}
                  min="1900-01-01"
                  max={getDateOfBirthMax(maxDate)}
                  onChange={(e) => {
                    setDate(e.target.value);

                    if (new Date(e.target.value) > maxDate) {
                      e.target.setCustomValidity(
                        'You must be 16 or over to enquire',
                      );
                    } else e.target.setCustomValidity('');
                  }}
                />
              </div>
              <div className="form-input-inner column-1">
                <label htmlFor="email">Email*</label>
                <input
                  type="email"
                  name="Email"
                  required
                  pattern="^.+@.+\.[a-zA-Z]{2,63}$"
                  maxLength="250"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="form-input-inner column-3">
                <label htmlFor="Contactno">Telephone*</label>
                <input
                  type="text"
                  name="Contactno"
                  required
                  placeholder="Enter your telephone"
                  value={contactno}
                  onChange={(e) => setContactno(e.target.value)}
                />
              </div>

              <label htmlFor="platform">Platform(s)</label>
              <fieldset name="platform" className="column-span">
                {platformObjectArray.map(
                  ({
                    label,
                    platformState,
                    setPlatformState,
                    numberSubsState,
                    setNumberSubsState,
                    usernameState,
                    setUsernameState,
                    gridColumn,
                  }) => {
                    return (
                      <>
                        <div
                          className={`form-checkbox-input-container ${gridColumn}`}
                        >
                          <div className="form-checkbox-container">
                            <input
                              className="checkbox"
                              type="checkbox"
                              name={label}
                              id={label}
                              checked={platformState}
                              onChange={(e) => {
                                e.target.checked
                                  ? setPlatformState(true)
                                  : setPlatformState(false);
                              }}
                            />
                            <label htmlFor={label}>{label}</label>
                          </div>
                          {platformState && (
                            <div className="form-checkbox-input-inner">
                              <div className="form-input-inner">
                                <label htmlFor="NumberOfSubscribers">
                                  Number of Subscribers*
                                </label>
                                <input
                                  type="text"
                                  name="NumberOfSubscribers"
                                  value={numberSubsState}
                                  onChange={(e) =>
                                    setNumberSubsState(e.target.value)
                                  }
                                />
                              </div>
                              <div className="form-input-inner">
                                <label htmlFor="Username">Username*</label>
                                <input
                                  type="text"
                                  name="Username"
                                  value={usernameState}
                                  onChange={(e) =>
                                    setUsernameState(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    );
                  },
                )}
              </fieldset>

              <div className="form-checkbox-container">
                <input
                  className="checkbox"
                  type="checkbox"
                  name="existing-customer"
                  checked={existingCustomer}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setExistingCustomer(true);
                    } else {
                      setExistingCustomer(false);
                    }
                  }}
                />
                <label htmlFor="existing-customer">
                  Are you an existing Lit Fibre customer?
                </label>
              </div>
              {existingCustomer && (
                <div className="form-input-inner column-3">
                  <label htmlFor="AccountNumber">Account Number*</label>
                  <input
                    type="text"
                    name="AccountNumber"
                    required
                    placeholder="Enter your account number"
                    value={accountNumber}
                    onChange={(e) => setAccountNumber(e.target.value)}
                  />
                </div>
              )}

              <div className="form-input-inner column-span">
                <label htmlFor="Message">Tell us about yourself*</label>
                <textarea
                  minLength={10}
                  name="Message"
                  rows={11}
                  value={message}
                  required
                  placeholder="Enter your message"
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
              <div className="form-checkbox-container column-span">
                <input
                  className="checkbox"
                  type="checkbox"
                  required
                  name="terms-and-conditions"
                  checked={privacyOptIn}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setPrivacyOptIn(true);
                    } else {
                      setPrivacyOptIn(false);
                    }
                  }}
                />
                <p>
                  By providing my details. I consent to Lit Fibre processing and
                  storing this information in accordance with it’s{' '}
                  <button onClick={switchDialog}>Privacy Policy</button> and
                  using these details to send me information about Lit Fibre’s
                  services. I understand that I may change my mind and
                  unsubscribe at any time.{' '}
                </p>
                <Modal
                  animation={animation}
                  dialogShow={dialogShow}
                  modal={modal}
                  switchDialog={switchDialog}
                >
                  <div className="modal-simple-website">
                    <SimplePagePopUp
                      simpleModularContent={
                        legalTermsContent[0].terms.simpleModularContent
                      }
                      title={legalTermsContent[0].terms.title}
                      seo={legalTermsContent[0].terms.seo}
                      slug={legalTermsContent[0].terms.slug}
                    />
                  </div>
                </Modal>
              </div>
            </div>
            <div className="form-single-button-container">
              <button type="submit" className="button-blue">
                Submit
              </button>
            </div>
          </form>
        </div>
      )}

      {formSubmit && (
        <div className="form-wrapper">
          <div className="form">
            <div className="form-submitted">
              <h5>Great, your enquiry has been sent!</h5>
              <p>One of our team will be in touch.</p>
            </div>
          </div>
        </div>
      )}
      {formSubmit && formSubmitError && (
        <div className="form-wrapper">
          <div className="form">
            <div className="form-submitted">
              <h5>{formSubmitError}</h5>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModularInfluencerForm;
export const fragment = graphql`
  fragment ModularInfluencerForm on DatoCmsInfluencerForm {
    internal {
      type
    }
    formHeading {
      value
    }
    legalTermsContent {
      terms {
        slug
        title
        simpleModularContent {
          ...ModularSimpleHero
          ...ModularParagraph
          ...ModularSimpleContent
        }
      }
    }
  }
`;
